import type { CompanyFilter } from './companyFilter.ts';

// Builds the Vendors-list URL a dashboard tile links to, carrying the active
// dashboard search (q) + filters so the list lands pre-filtered. Maps to the
// params Companies.tsx already parses: status, type, region, station, q.
export function dashboardListUrl(
  tileStatus: string,
  query: string,
  filter: CompanyFilter,
): string {
  const params = new URLSearchParams();
  if (tileStatus !== 'all') params.set('status', tileStatus);
  const q = query.trim();
  if (q) params.set('q', q);
  for (const t of filter.contractorTypes) params.append('type', t);
  for (const r of filter.clusterRegions) params.append('region', r);
  for (const s of filter.stations) params.append('station', s);
  const qs = params.toString();
  return qs ? `/admin/companies?${qs}` : '/admin/companies';
}
